<template>
  <div class="position-relative">
    <div class="loading d-none" id="loadingcontainer">
      <h3>Fetching Project Details...</h3>
    </div>
    <div class="breadcrumb-container">
      <b-breadcrumb :items="breadcrumb_items"></b-breadcrumb>
    </div>
    <div id="crequestcontainer" v-if="customFields.length">
      <h2 class="mb-3 text-center text-decoration-underline">
        Create a Payment Request
      </h2>
      <div class="d-flex flex-column">
        <div class="row">
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.selectedProject.$error }"
          >
            <label for="projectname" class="form__label">
              Project Name
              <span class="text-danger">*</span>
            </label>
            <div class="d-flex">
              <multiselect
                v-model.trim="$v.selectedProject.$model"
                id="ajax"
                label="title"
                track-by="id"
                placeholder="Type to search"
                :internal-search="true"
                open-direction="bottom"
                :options="projects"
                :loading="isLoading"
                :close-on-select="true"
                :max-height="600"
                :option-height="30"
                @search-change="fetchProjects"
                @select="getProjectDetails"
                @remove="removeProjectDetails"
              >
                <template slot="tag" slot-scope="{ option }">
                  <span class="custom__tag">
                    <span>{{ option.title }}</span>
                  </span>
                </template>
                <span slot="noResult">Oops! No Projects found.</span>
              </multiselect>
              <div
                v-if="
                  selectedProject && Object.keys(selectedProject).length > 0
                "
                class="ml-2"
              >
                <SOWDetails :project-name="selectedProject.title" />
              </div>
            </div>
            <div class="error" v-if="$v.selectedProject.$error">
              Project name is required
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.cryptotype.$error }"
          >
            <label for="cryptotype" class="form__label">
              Crypto Type
              <span class="text-danger">*</span>
            </label>
            <multiselect
              v-model="cryptotype"
              :options="crypto_types"
              placeholder="Select Crypto Type"
            ></multiselect>
            <div class="error" v-if="$v.cryptotype.$error">
              Crypto type is required
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.variant_name.$error }"
          >
            <label for="variantname">
              Variant
              <span class="text-danger">*</span>
            </label>
            <div>
            <MultiSelect
            v-model="variant_name"
            :options="variants"
            id="variant_multiselect"
            :filter="true"
            filterPlaceholder="Search Variant"
            class="custom-multiselect"
            display="chip"
            placeholder="Select Variants"
            ref="multiSelect"
            @before-hide="oncloseVariant()"
          >
          </MultiSelect>
        <div class="error" v-if="$v.variant_name.$error">
          Variant Name is required
        </div>
      </div>
        </div>
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.carrier_name.$error }"
          >
            <label>
              Carrier
              <span class="text-danger">*</span>
            </label>
            <multiselect
              v-model="carrier_name"
              :options="carriers"
              placeholder="Select Carrier"
              :clear-on-select="false"
            ></multiselect>
            <div class="error" v-if="$v.carrier_name.$error">
              Carrier is required
            </div>
          </div>
          <div class="form-group col-12" v-if="groups.length">
            <label for="">Breach Coach</label>
            <div class="d-flex gap-1">
              <div v-for="group in groups" :key="group.id" class="group">
                {{ group.name }}
              </div>
            </div>
          </div>
          <div
            class="form-group col-12"
            :class="{ 'form-group--error': $v.communication_details.$error }"
          >
            <label>
              Communication Details
              <span class="text-danger">*</span>
            </label>
            <div
              v-for="(detail, index) in communication_details"
              :key="index"
              class="row mb-2"
            >
              <div class="col-6 ">
                <select
                  name=""
                  id=""
                  class="custom-select"
                  v-model="detail.type"
                >
                  <option value="Telegram Id">Telegram Id</option>
                  <option value="Threat Actor Email">Threat Actor Email</option>
                  <option value="TOR Chat Link">TOR Chat Link</option>
                </select>
              </div>
              <div class="col-6 display-flex">
                <input
                  type="text"
                  class="form-control"
                  v-model="detail.value"
                  placeholder="Enter Value"
                  maxlength="250"
                />
                <font-awesome-icon
                  class="fa-2x text-success ml-2"
                  :icon="['fas', 'plus-circle']"
                  title="Add new detail"
                  @click="
                    addNewPathNode(
                      communication_details,
                      'communication_detail'
                    )
                  "
                  v-if="index == communication_details.length - 1"
                />
                <font-awesome-icon
                  class="fa-2x text-danger ml-2"
                  :icon="['fas', 'minus-circle']"
                  v-if="communication_details.length > 1"
                  @click="removePathNode(communication_details, index)"
                />
              </div>
              
              <div
                class="error col-12"
                v-if="
                  $v.communication_details.$each[index].$error &&
                  !$v.communication_details.$each[index].type.required &&
                  !$v.communication_details.$each[index].value.required
                "
              >
                Both Type and Value are Required
              </div>
              <div
                class="error col-12"
                v-else-if="
                  $v.communication_details.$each[index].$error &&
                  !$v.communication_details.$each[index].type.required
                "
              >
                Type is Required
              </div>
              <div
                class="error col-12"
                v-else-if="
                  $v.communication_details.$each[index].$error &&
                  !$v.communication_details.$each[index].value.required
                "
              >
                Value is Required
              </div>
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.client_domain_name.$error }"
          >
            <label for="clientdomainname">
              Domain name of Client
              <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              name="clientdomainname"
              v-model="client_domain_name"
            />
            <div class="error" v-if="$v.client_domain_name.$error">
              Domain name of Client is required
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.ransom_payment_reason.$error }"
          >
            <label for="ransompaymentreason" class="">
              Ransom Payment Reason <span class="text-danger">*</span></label
            >
            <multiselect
              v-model="ransom_payment_reason"
              :options="ransom_payment_reasons"
              placeholder="Select Ransom Payment Reason"
            ></multiselect>
            <div class="error" v-if="$v.ransom_payment_reason.$error">
              Ransom Payment Reason is required
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="form-group col-6"
            :class="{
              'form-group--error': $v.ransomdemandedin.$error,
            }"
          >
            <label for="ransomdemandedin">
              Currency of the TA's Initial Demand <span class="text-danger">*</span>
            </label>
            <select
              class="custom-select"
              name="ransomdemandedin"
              v-model="ransomdemandedin"
            >
              <option value="btc">BTC</option>
              <option value="usd">USD</option>
            </select>
            <div class="error" v-if="$v.ransomdemandedin.$error">
              Ransom Demanded In value is required.
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{
              'form-group--error': $v.ransompaymentmode.$error,
            }"
          >
            <label for="ransompaymentmode">
              Ransom Payment Mode <span class="text-danger">*</span>
            </label>
            <select
              class="custom-select"
              name="ransompaymentmode"
              v-model="ransompaymentmode"
            >
              <option value="prepaid">Prepaid (Arete Pays)</option>
              <option value="wire">Wire (Client Pays)</option>
            </select>
            <div class="error" v-if="$v.ransompaymentmode.$error">
              Ransom Payment Mode is required.
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="form-group col-5">
            <label for="cryptooriginalransomdemand">
              Crypto Original Ransom Demand
              <template v-if="currencyUnit !== ''"
                >({{ currencyUnit }})</template
              >
            </label>
            <input
              type="number"
              class="form-control"
              name="clientdomainname"
              id="cryptooriginalransomdemand"
              v-model="crypto_original_ransom_demand"
              maxlength="12"
              step="any"
              @input="validateInput('cryptooriginalransomdemand')"
              onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 173"
            />
          </div>
          <div
            class="form-group col-5"
            :class="{
              'form-group--error': $v.original_ransom_demand.$error,
            }"
          >
            <label for="OriginalRansomDemand">
              Original Ransom Demand
              <span
                class="text-danger"
                v-if="original_ransom_demand === ''"
                >*</span
              >
            </label>
            <input
              type="number"
              class="form-control"
              name="OriginalRansomDemand"
              id="OriginalRansomDemand"
              v-model="original_ransom_demand"
              maxlength="12"
              step="any"
              @input="onOriginalRansomDemandCurrentyUpdated"
              onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 173"
            />
            <div class="error" v-if="$v.original_ransom_demand.$error">
              Original Ransom Demand in Crypto/Currency is required
            </div>
          </div>
          <div
            class="form-group col-2"
            :class="{
              'form-group--error': $v.original_ransom_demand_currency.$error,
            }"
          >
            <label for="OriginalRansomDemandCurrency">
              Currency
              <span
                class="text-danger"
                v-if="original_ransom_demand === ''"
                >*</span
              >
            </label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="original_ransom_demand_currency"
            >
              <option v-for="c in currencies" :key="c.value" :value="c.value">
                {{ c.title }}
              </option>
            </select>
            <div class="error" v-if="$v.original_ransom_demand_currency.$error">
              Currency is required
            </div>
          </div>
          <div
            class="form-group col-12"
            :class="{
              'form-group--error': $v.initial_ransom_payment_files.$error,
            }"
          >
            <label class="display-flex">
              Initial Ransom Demand Screenshots 
              <span class="text-danger">*</span>
              <FileUploadInfo>  </FileUploadInfo>
            </label>
         
            <FileUploadGrid id="initialRansomePayment" v-model="initial_ransom_payment_files"></FileUploadGrid>
              <div
              class="error"
              v-if="
                $v.initial_ransom_payment_files.$error &&
                !$v.initial_ransom_payment_files.allowdedFileTypes
              "
            >
              {{fileTypeNotSupported}}
            </div>
            
            <div
              class="error"
              v-if="
                !$v.initial_ransom_payment_files.required &&
                $v.initial_ransom_payment_files.$error
              "
            >
              Please upload a valid file
            </div>
            <div
              class="error"
              v-if="
                $v.initial_ransom_payment_files.$error &&
                !$v.initial_ransom_payment_files.unique
              "
            >
              Files must be unique
            </div>
            <div  v-if="$v.initial_ransom_payment_files.$error && !$v.initial_ransom_payment_files.uniqueGlobal"
              class="error"
            >
               {{errorMsgAlreadyUploadedFile}}
            </div>
          </div>
          <div
            class="form-group col-5">
            <label for="cryptonegotiatedransomdemand">
              Crypto Negotiated Ransom Demand
              <template v-if="currencyUnit !== ''"
                >({{ currencyUnit }})</template
              >
            </label>
            <input
              type="number"
              class="form-control"
              name="cryptonegotiatedransomdemand"
              id="cryptonegotiatedransomdemand"
              v-model="crypto_negotiated_ransom_demand"
              maxlength="12"
              step="any"
              @input="validateInput('cryptonegotiatedransomdemand')"
              onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 173"
            />
          </div>
          <div
            class="form-group col-5"
            :class="{
              'form-group--error': $v.negotiated_ransom_demand.$error,
            }"
          >
            <label for="negotiatedRansomDemand">
              Negotiated Ransom Demand
              <span
                class="text-danger"
                v-if="negotiated_ransom_demand === ''"
                >*</span
              >
            </label>
            <input
              type="number"
              class="form-control"
              name="negotiatedRansomDemand"
              id="negotiatedRansomDemand"
              v-model="negotiated_ransom_demand"
              maxlength="12"
              step="any"
              @input="onNegotiatedRansomDemandCurrentyUpdated"
              onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 173"
            />
            <div class="error" v-if="$v.negotiated_ransom_demand.$error">
              Negotiated Ransom Demand in Crypto/Currency is required
            </div>
          </div>
          <div
            class="form-group col-2"
            :class="{
              'form-group--error': $v.negotiated_ransom_demand_currency.$error,
            }"
          >
            <label for="NegotiatedRansomDemandCurrency">
              Currency
              <span
                class="text-danger"
                v-if="negotiated_ransom_demand === ''"
                >*</span
              >
            </label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="negotiated_ransom_demand_currency"
            >
              <option v-for="c in currencies" :key="c.value" :value="c.value">
                {{ c.title }}
              </option>
            </select>
            <div
              class="error"
              v-if="$v.negotiated_ransom_demand_currency.$error"
            >
              Currency is required
            </div>
          </div>
          <div
            class="form-group col-12"
            :class="{
              'form-group--error': $v.final_ransom_payment_files.$error,
            }"
          >
            <label class="display-flex">
              Final Ransom Demand Screenshots
              <span class="text-danger">*</span>
              <FileUploadInfo> </FileUploadInfo>
            </label>
            <FileUploadGrid v-model="final_ransom_payment_files"></FileUploadGrid>

                <div
              class="error"
              v-if="
                $v.final_ransom_payment_files.$error &&
                !$v.final_ransom_payment_files.allowdedFileTypes
              "
            >
              {{fileTypeNotSupported}}
            </div>

            <div
              class="error"
              v-if="
                !$v.final_ransom_payment_files.required &&
                $v.final_ransom_payment_files.$error
              "
            >
              Please upload a valid file
            </div>
            <div
              class="error"
              v-if="
                $v.final_ransom_payment_files.$error &&
                !$v.final_ransom_payment_files.unique
              "
            >
              Files must be Unique
            </div>
             <div  v-if="$v.final_ransom_payment_files.$error && !$v.final_ransom_payment_files.uniqueGlobal"
              class="error"
            >
              {{errorMsgAlreadyUploadedFile}}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label for="negotiationstartdatetime"
              >Negotiation Start Date and Time
              <span class="text-danger">*</span></label
            >
            <div>
              <date-picker
                v-model="negotiationstartdatetime"
                format="DD-MMM-YYYY HH:mm"
                type="datetime"
                value-type="DD-MMM-YYYY HH:mm"
              ></date-picker>
            </div>
            <div class="error" v-if="$v.negotiationstartdatetime.$error">
              Negotiation Start Date and Time is required.
            </div>
          </div>
          <div class="form-group col-6">
            <label for="negotiationenddatetime"
              >Negotiation End Date and Time
              <span class="text-danger">*</span></label
            >
            <div>
              <date-picker
                v-model="negotiationenddatetime"
                format="DD-MMM-YYYY HH:mm"
                type="datetime"
                value-type="DD-MMM-YYYY HH:mm"
              ></date-picker>
            </div>
            <div class="error" v-if="$v.negotiationenddatetime.$error">
              Negotiation End Date and Time is required.
            </div>
          </div>
        </div>
        <!-- <div class="row" style="display:none">
          <div class="form-group col-4">
            <label class="current_offer_from_arete" for="currentofferfromarete"
              >Current Offer from Arete</label>
             <InputNumber
              name="currentofferfromarete"
              id="currentofferfromarete"
              class="current_offer_from_arete"
              v-model="current_offer_from_arete"
              step="any"
            />
          </div>
          <div class="form-group col-2">
            <label for="current_offer_from_arete_currency"> Currency </label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="current_offer_from_arete_currency"
            >
              <option value=""></option>
              <option v-for="c in currencies" :key="c.value" :value="c.value">
                {{ c.title }}
              </option>
            </select>
          </div>
          <div class="form-group col-4">
            <label class="current_offer_from_ta" for="currentofferfromarete">Current Offer from TA</label>
             <InputNumber
              name="current_offer_from_ta"
              id="currentofferfromarete"
              class="current_offer_from_ta"
              v-model="current_offer_from_ta"
              step="any"
            />
          </div>
          <div class="form-group col-2">
            <label for="current_offer_from_ta_currency"> Currency </label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="current_offer_from_ta_currency"
            >
              <option value=""></option>
              <option v-for="c in currencies" :key="c.value" :value="c.value">
                {{ c.title }}
              </option>
            </select>
          </div>
        </div> -->
        <div
          class="form-group"
          :class="{
            'form-group--error': $v.transactionfee.$error,
          }"
        >
          <label class="transactionfee" for="trasectionfee"
            >Transaction Fee (%)<span class="text-danger">*</span></label
          >
          <input
            type="number"
            class="form-control"
            name="current_offer_from_ta"
            id="trasectionfee"
            v-model="transactionfee"
            maxlength="5"
            step="any"
            @input="validateInput('trasectionfee')"
            onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 173"
          />
          <div
            class="error"
            v-if="$v.transactionfee.$error && !$v.transactionfee.required"
          >
            Transaction Fee is required
          </div>
          <div
            class="error col-12 d-flex"
            v-if="$v.transactionfee.$error && !$v.transactionfee.between"
          >
            Must be between {{ $v.transactionfee.$params.between.min }} and
            {{ $v.transactionfee.$params.between.max }}
          </div>
        </div>
        <div class="form-group" style="display:none">
          <label for="paymentrequesteddate">Payment requested date</label>
          <div>
            <date-picker
              v-model="paymentrequesteddate"
              format="DD-MMM-YYYY"
              value-type="format"
            ></date-picker>
          </div>
        </div>
        <div class="form-group" >
          <div class="row" :class="{ 'form-group--error': $v.walletid.$error }">

          
          <label for="walletid" class="col-12 d-flex">
            Wallet ID 1
            <span class="text-danger">*</span>
          </label>
            <div class="col-12 d-flex">
              <input type="text" class="form-control" name="walletid" id="walletid" :maxlength="75"
                v-model.trim="$v.walletid.$model" @input="validateInput('walletid')" />
              <button class="btn bgprimarycolor text-white ml-2" id="btncheckwallet" @click="checkWalletId"
                :disabled="walletid === ''">
                Check
              </button>
              <font-awesome-icon class="fa-2x text-success ml-2" :icon="['fas', 'plus-circle']" title="Add new detail"
                @click="addSecondaryWallet()" v-if="!isSecondaryWalletActivated" />
            </div>
            <div class="col-12 d-flex" v-if="walletProjects">
              <div v-if="walletProjects.length > 0" class="mt-3">
                <label for="">Wallet Used in Previous Projects?</label> : Yes
                <br />
                <ul>
                  <li v-for="project in walletProjects" :key="project.projectId">
                    <strong>{{ project.name }}</strong>
                  </li>
                </ul>
              </div>
              <div v-else class="mt-3">
                <label for="">Wallet Used in Previous Projects?</label> : No
              </div>
            </div>
            <div class="error col-12 d-flex" v-if="$v.walletid.$error && !$v.walletid.required">
              Wallet id 1 is required
            </div>
            <div class="error col-12 d-flex" v-if="isSecondaryWalletActivated && $v.walletid.$error && !$v.walletid.unique">
              Wallet id 1 must be unique
            </div>

          <div class="col-12 mt-3" :class="{ 'form-group--error': $v.wallet_screenshot_files.$error }">
            <label class="display-flex">
              Upload Wallet Id 1 Screenshots
              <span class="text-danger">*</span>
              <FileUploadInfo> </FileUploadInfo>
            </label>
            <FileUploadGrid v-model="wallet_screenshot_files"></FileUploadGrid>

            <div class="error" v-if="$v.wallet_screenshot_files.$error &&
              !$v.wallet_screenshot_files.allowdedFileTypes
              ">
              {{ fileTypeNotSupported }}
            </div>

            <div class="error" v-if="!$v.wallet_screenshot_files.required && $v.wallet_screenshot_files.$error
              ">
              Please upload a valid file
            </div>
            <div class="error" v-else-if="$v.wallet_screenshot_files.$error && !$v.wallet_screenshot_files.unique
              ">
              Files must be unique.
            </div>
            <div v-if="$v.wallet_screenshot_files.$error && !$v.wallet_screenshot_files.uniqueGlobal" class="error">
              {{ errorMsgAlreadyUploadedFile }}
            </div>

          </div>
        </div>
          <!-- secondary wallet -->


          <div v-if="isSecondaryWalletActivated" class="row">
            <label for="walletid" class="col-12 d-flex">
              Wallet ID 2
              <span class="text-danger">*</span>
            </label>
            <div class="col-12 d-flex">
              <input type="text" class="form-control" name="secondaryWalletid" id="secondarywalletid" :maxlength="75"
                v-model.trim="$v.secondaryWalletid.$model" @input="validateInput('secondarywalletid')" />
              <button class="btn bgprimarycolor text-white ml-2" id="btnchecksecondarywallet"
                @click="checkSecondaryWalletId" :disabled="secondaryWalletid === ''">
                Check
              </button>

              <font-awesome-icon class="fa-2x text-danger ml-2" :icon="['fas', 'minus-circle']"
                @click="removeSecondaryWallet()" />
            </div>
            <div class="col-12 d-flex" v-if="secondaryWalletProjects">
              <div v-if="secondaryWalletProjects.length > 0" class="mt-3">
                <label for="">Wallet Used in Previous Projects?</label> : Yes
                <br />
                <ul>
                  <li v-for="project in secondaryWalletProjects" :key="project.projectId">
                    <strong>{{ project.name }}</strong>
                  </li>
                </ul>
              </div>
              <div v-else class="mt-3">
                <label for="">Wallet Used in Previous Projects?</label> : No
              </div>
            </div>
            <div class="error col-12 d-flex" v-if="$v.secondaryWalletid.$error && !$v.secondaryWalletid.required">
              Wallet id 2 is required
            </div>
            <div class="error col-12 d-flex" v-if="$v.secondaryWalletid.$error && !$v.secondaryWalletid.unique">
              Wallet id 2 must be unique
            </div>
            <div class="col-12 mt-3" :class="{ 'form-group--error': $v.wallet_id_2_screenshot_files.$error }">
              <label class="display-flex">
                Upload Wallet Id 2 Screenshots
                <span class="text-danger">*</span>
                <FileUploadInfo> </FileUploadInfo>
              </label>
              <FileUploadGrid v-model="wallet_id_2_screenshot_files"></FileUploadGrid>

              <div class="error" v-if="$v.wallet_id_2_screenshot_files.$error &&
                !$v.wallet_id_2_screenshot_files.allowdedFileTypes
                ">
                {{ fileTypeNotSupported }}
              </div>

              <div class="error" v-if="!$v.wallet_id_2_screenshot_files.required && $v.wallet_id_2_screenshot_files.$error
                ">
                Please upload a valid file
              </div>
              <div class="error" v-else-if="$v.wallet_id_2_screenshot_files.$error && !$v.wallet_id_2_screenshot_files.unique
                ">
                Files must be unique.
              </div>
              <div v-if="$v.wallet_id_2_screenshot_files.$error && !$v.wallet_id_2_screenshot_files.uniqueGlobal"
                class="error">
                {{ errorMsgAlreadyUploadedFile }}
              </div>

            </div>
          </div>
        </div>
        <div class="form-group"
            :class="{ 'form-group--error': $v.walletNote.$error }" >
            <label for="walletid" class="">
            Wallet Notes
            <span v-if="isSecondaryWalletActivated" class="text-danger">*</span>
          </label>
              <div class="">
              <textarea class="form-control"
              name="walletNote"
              id="walletNote"
              
              v-model.trim="$v.walletNote.$model">
              </textarea>
          </div>
          <div class="error" v-if="$v.walletNote.$error && !$v.walletNote.required">
            Wallet note is required
          </div>
          </div>
        <div
            class="form-group"
            :class="{
              'form-group--error': $v.copy_of_ransome_note_files.$error,
            }">
            <label class="display-flex">Copy of Ransom Note 
              <span class="text-danger">*</span>
              <FileUploadInfo> </FileUploadInfo>
            </label>
             <FileUploadGrid v-model="copy_of_ransome_note_files"></FileUploadGrid>
            <div
              class="error"
              v-if="
                !$v.copy_of_ransome_note_files.required &&
                $v.copy_of_ransome_note_files.$error
              "
            >
              Please upload a valid file
            </div>
            <div
              class="error"
              v-if="
                $v.copy_of_ransome_note_files.$error &&
                !$v.copy_of_ransome_note_files.allowdedFileTypes
              "
            >
              {{fileTypeNotSupported}}
            </div>
            <div
              class="error"
              v-if="
                $v.copy_of_ransome_note_files.$error &&
                !$v.copy_of_ransome_note_files.unique
              "
            >
              Files must be unique
            </div>
                  <div  v-if="$v.copy_of_ransome_note_files.$error && !$v.copy_of_ransome_note_files.uniqueGlobal"
              class="error"
            >
               {{errorMsgAlreadyUploadedFile}}
            </div>
          </div>
          <div
            class="form-group"
            :class="{
              'form-group--error': $v.complete_chat_history_files.$error,
            }">
            <label class="display-flex">Complete Chat History 
              <span class="text-danger">*</span>
              <FileUploadInfo> </FileUploadInfo>
            </label>
            <FileUploadGrid v-model="complete_chat_history_files"></FileUploadGrid>

            <div
              class="error"
              v-if="
                $v.complete_chat_history_files.$error &&
                !$v.complete_chat_history_files.allowdedFileTypes
              "
            >
              {{fileTypeNotSupported}}
            </div>

            <div
              class="error"
              v-if="
                !$v.complete_chat_history_files.required &&
                $v.complete_chat_history_files.$error
              "
            >
              Please upload a valid file
            </div>
            <div
              class="error"
              v-if="
                $v.complete_chat_history_files.$error &&
                !$v.complete_chat_history_files.unique
              "
            >
              Files must be unique
            </div>
            <div  v-if="$v.complete_chat_history_files.$error && !$v.complete_chat_history_files.uniqueGlobal"
              class="error"
            >
               {{errorMsgAlreadyUploadedFile}}
            </div>
          </div>
      </div>
        <div class="form-group" :class="{ 'form-group--error': ($v.pol_files.$error || $v.confirmation_communication.$error || $v.has_proof_of_life_completed.$error)  }">
          <label for="pol" class="align-middle"
            >Has Proof of Life been Completed?
            <span class="text-danger">*</span></label
          >
          <select @change="onPolChoiceChanged"
            id="haspolcompleted"
            v-model="has_proof_of_life_completed"
            class="custom-select"
          >
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
          <div
            class="error"
            v-if="
              !$v.has_proof_of_life_completed.required &&
              $v.has_proof_of_life_completed.$error
            "
          >
            Please select an option
          </div>
        </div>
        <div
          class="form-group"
          v-if="has_proof_of_life_completed === 'true'"
          :class="{ 'form-group--error': $v.pol_files.$error && !$v.pol_files.required }"
        >
          <label class="display-flex"
            >Proof of Life Screenshots 
            <span class="text-danger">*</span>
            <FileUploadInfo> </FileUploadInfo>
            </label
          >
          <FileUploadGrid v-model="pol_files"></FileUploadGrid>
            <div
              class="error"
              v-if="
                $v.pol_files.$error &&
                !$v.pol_files.allowdedFileTypes
              "
            >
              {{fileTypeNotSupported}}
            </div>

          <div
            class="error"
            v-if="!$v.pol_files.required && $v.pol_files.$error"
          >
            Please upload a valid Proof of Life Screenshot
          </div>
          <div class="error" v-if="$v.pol_files.$error && !$v.pol_files.unique">
            Files must be Unique
          </div>
            <div  v-if="$v.pol_files.$error && !$v.pol_files.uniqueGlobal"
              class="error"
            >
               {{errorMsgAlreadyUploadedFile}}
            </div>
        </div>
        <div
          class="form-group"
          v-else-if="has_proof_of_life_completed === 'false'"
          :class="{ 'form-group--error': $v.confirmation_communication.$error }"
        >
          <label>
            Reason Why Proof of Life is Not Needed
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            v-model="confirmation_communication"
          />
          <div
            class="error"
            v-if="
              $v.confirmation_communication.$error &&
              !$v.confirmation_communication.required
            "
          >
            Please enter Confirmation Communication Message
          </div>
        </div>
        <div
          class="form-group"
          :class="{ 'form-group--error': $v.client_physical_address.$error }"
        >
          <label>
            Client Physical Address
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            v-model="client_physical_address"
          />
          <div class="error" v-if="$v.client_physical_address.$error">
            Client Physical Address is Required
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label> Carrier Details </label>
            <div v-for="(carrier, index) in carrier_emails" :key="index">
              <div class="d-flex">
                <input
                  type="text"
                  class="form-control mb-2"
                  v-model="carrier.email"
                  placeholder="Email"
                />
                <input
                  type="text"
                  class="form-control ml-2"
                  placeholder="Full Name"
                  v-model.trim="carrier.full_name"
                />
                <font-awesome-icon
                  class="fa-2x text-success ml-2"
                  :icon="['fas', 'plus-circle']"
                  title="Add new Email"
                  @click="addNewPathNode(carrier_emails, 'carrier')"
                  v-if="index == carrier_emails.length - 1"
                />
                <font-awesome-icon
                  class="fa-2x text-danger ml-2"
                  :icon="['fas', 'minus-circle']"
                  v-if="carrier_emails.length > 1"
                  @click="removePathNode(carrier_emails, index)"
                />
              </div>
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.arete_emails.$error }"
          >
            <label>
              Arete Emails
              <span class="text-danger">*</span>
            </label>
            <div v-for="(email, index) in arete_emails" :key="index">
              <div class="d-flex">
                <multiselect
                  v-model="email.email"
                  :options="arete_master_emails"
                  label="mail"
                  track-by="mail"
                  class="mb-2"
                  placeholder="Select email"
                ></multiselect>

                <font-awesome-icon
                  class="fa-2x text-success ml-2"
                  :icon="['fas', 'plus-circle']"
                  title="Add new Email"
                  @click="addNewPathNode(arete_emails, 'areteuser')"
                  v-if="index == arete_emails.length - 1"
                />
                <font-awesome-icon
                  class="fa-2x text-danger ml-2"
                  :icon="['fas', 'minus-circle']"
                  v-if="arete_emails.length > 1"
                  @click="removePathNode(arete_emails, index)"
                />
              </div>
              <div
                class="error"
                v-if="
                  $v.arete_emails.$each[index].$error &&
                  !$v.arete_emails.$each[index].email.required
                "
              >
                Arete Email is Required
              </div>
              <div
                class="error"
                v-else-if="
                  $v.arete_emails.$each[index].$error &&
                  !$v.arete_emails.$each[index].email.email
                "
              >
                Please enter a Valid Email
              </div>
              <div
                class="error"
                v-else-if="$v.arete_emails.$each[index].$error"
              >
                User should be from Arete
              </div>
            </div>
          </div>
        </div>
        <div
          class="form-group"
          :class="{ 'form-group--error': $v.client_emails.$error }"
        >
          <label>
            Client Details
            <span class="text-danger">*</span>
          </label>
          <div
            v-for="(client, index) in client_emails"
            :key="index"
            class="mb-2"
          >
            <div class="d-flex align-items-center mb-2">
              <div class="input-group w-50">
                <div class="input-group-prepend">
                  <div class="input-group-text text-black">
                    <input
                      type="checkbox"
                      v-model="client.is_primary"
                      data-title="Is Primary?"
                      class="mr-2"
                    />
                    Is Primary
                  </div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="client.email"
                  PlaceHolder="Email"
                  @change="
                    checkEmail($event.target.value, 'client_emails', index)
                  "
                />
              </div>
              <div class="ml-2 w-50">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Full Name"
                  v-model="client.full_name"
                />
              </div>
              <font-awesome-icon
                class="fa-2x text-danger ml-2"
                :icon="['fas', 'minus-circle']"
                title="Remove new Email"
                v-if="client_emails.length > 1"
                @click="removePathNode(client_emails, index)"
              />
              <font-awesome-icon
                class="fa-2x text-success ml-2"
                :icon="['fas', 'plus-circle']"
                title="Add new Email"
                @click="addNewPathNode(client_emails, 'client')"
                v-if="index == client_emails.length - 1"
              />
            </div>
            <div
              class="error"
              v-if="
                $v.client_emails.$each[index].$error &&
                !$v.client_emails.$each[index].email.required &&
                !$v.client_emails.$each[index].full_name.required
              "
            >
              Both Client Email and Full Name are Required
            </div>
            <div
              class="error"
              v-else-if="
                $v.client_emails.$each[index].$error &&
                !$v.client_emails.$each[index].email.email
              "
            >
              Please enter a Valid Email
            </div>
            <div
              class="error"
              v-else-if="
                $v.client_emails.$each[index].$error &&
                !$v.client_emails.$each[index].email.required
              "
            >
              Client Email is Required
            </div>
            <div
              class="error"
              v-else-if="
                $v.client_emails.$each[index].$error &&
                !$v.client_emails.$each[index].full_name.required
              "
            >
              Full Name is Required
            </div>
          </div>
        </div>
        <div
          class="form-group"
          :class="{ 'form-group--error': $v.counsel_emails.$error }"
        >
          <label> Counsel Details </label>
          <div v-for="(counsel, index) in counsel_emails" :key="index">
            <div class="d-flex align-items-center mb-2">
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <span class="mr-2 text-black" v-if="!counsel.is_associate">
                      <input
                        type="checkbox"
                        data-title="Is Partner?"
                        v-model="counsel.is_partner"
                        @click="makeCounselAsPartner(index)"
                        class="align-middle"
                      />
                      Is Partner?</span
                    >
                    <span class="mr-2 text-black" v-if="!counsel.is_partner">
                      <input
                        type="checkbox"
                        data-title="Is Associate?"
                        v-model="counsel.is_associate"
                        @click="makeCounselAsAssociate(index)"
                        class="align-middle"
                      />
                      Is Associate?</span
                    >
                  </div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="counsel.email"
                  placeholder="Email"
                  @change="
                    checkEmail($event.target.value, 'counsel_emails', index)
                  "
                />
              </div>
              <input
                type="text"
                class="form-control ml-2"
                placeholder="Full Name"
                v-model="counsel.full_name"
              />
              <font-awesome-icon
                class="fa-2x text-success ml-2"
                :icon="['fas', 'plus-circle']"
                title="Add new Email"
                @click="addNewPathNode(counsel_emails, 'counsel')"
                v-if="index == counsel_emails.length - 1"
              />
              <font-awesome-icon
                class="fa-2x text-danger ml-2"
                :icon="['fas', 'minus-circle']"
                v-if="counsel_emails.length > 1"
                @click="removePathNode(counsel_emails, index)"
              />
            </div>
            <div
              class="error"
              v-if="
                $v.counsel_emails.$each[index].$error &&
                !$v.counsel_emails.$each[index].email.required &&
                !$v.counsel_emails.$each[index].full_name.required
              "
            >
              Both Counsel Email and Full Name are Required
            </div>
            <div
              class="error"
              v-else-if="
                $v.counsel_emails.$each[index].$error &&
                !$v.counsel_emails.$each[index].email.email
              "
            >
              Please enter a Valid Email
            </div>
            <div
              class="error"
              v-else-if="
                $v.counsel_emails.$each[index].$error &&
                !$v.counsel_emails.$each[index].email.required
              "
            >
              Counsel Email is Required
            </div>
            <div
              class="error"
              v-else-if="
                $v.counsel_emails.$each[index].$error &&
                !$v.counsel_emails.$each[index].full_name.required
              "
            >
              Full Name is Required
            </div>
          </div>
        </div>
        <!-- <div class="form-group" style="display:none">
          <label>Notes about Threat Actor</label>
          <textarea
            class="form-control"
            v-model="notes_about_threat_actor"
          ></textarea>
        </div> -->
        <div class="form-group">
          <label class="display-flex">Threat Intel Document <FileUploadInfo> </FileUploadInfo></label>
          <FileUploadGrid id="threat_intel_files" v-model="threat_intel_files"></FileUploadGrid>
           <div  v-if="$v.threat_intel_files.$error && !$v.threat_intel_files.uniqueGlobal"
              class="error"
            >
              {{errorMsgAlreadyUploadedFile}}
            </div>
          <div class="error"
              v-if="
                $v.threat_intel_files.$error &&
                !$v.threat_intel_files.allowdedFileTypes
              "
            >
              {{fileTypeNotSupported}}
            </div>        
            </div>
   <div class="d-flex justify-content-end mt-3 mb-3 align-items-baseline">
        <label class="mr-2" v-if="isCreateWalletVisible"
          >Validate wallet ids to create a Request.</label
        >
        <button
          class="btn bgprimarycolor text-white"
          @click="createWalletRequest"
          :disabled="isCreateWalletVisible"
          id="createwalletrequest"
        >
          Create
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { required, email, requiredIf, between } from "vuelidate/lib/validators";
import walletService from "../services/walletService";
import projectService from "../services/projectService";
import Multiselect from "vue-multiselect";
import { EventBus } from "../EventBus";
import FileUploadGrid from "./FileUploadGrid";
import SOWDetails from "./SOWDetails";
import userService from "@/services/userService";
import InputNumber from "./InputNumber.vue";
import FileUploadInfo from "./FileUploadInfo.vue";
import Vue from "vue";

export default {
  name: "CreateWallet",
  components: {
    DatePicker,
    Multiselect,
    FileUploadGrid,
    SOWDetails,
    InputNumber,
    FileUploadInfo,
  },
  created() {
    window.addEventListener('resize', () => {
      if(screen.availWidth > 1500){
        this.variantLimit = 3;
      } else if(screen.availWidth > 1100 && screen.availWidth < 1500) {
        this.variantLimit = 2;
      } else {
        this.variantLimit = 1;
      }
});
    EventBus.$emit("toast", {
      title: "",
      message: "Fetching Custom Fields and Emails Master data",
      variant: "success",
    });

    Promise.all([
      projectService.getCustomFields(),
      userService.getUsers(),
    ]).then((result) => {
      this.$store.commit("addCustomFields", result[0].data.data);
      this.arete_master_emails = result[1].data.data;
    });

  },
  methods: {
    validateInput(input) {
      switch(input){
        case 'cryptooriginalransomdemand' : 
        if (this.crypto_original_ransom_demand.length > 12)
        this.crypto_original_ransom_demand = this.crypto_original_ransom_demand.slice(0, 12);
        return this.crypto_original_ransom_demand;

        case 'originalRansomDemand' : 
        if (this.original_ransom_demand.length > 12) 
        this.original_ransom_demand = this.original_ransom_demand.slice(0, 12);
        return this.original_ransom_demand;

        case 'cryptonegotiatedransomdemand' : 
        if (this.crypto_negotiated_ransom_demand.length > 12) 
        this.crypto_negotiated_ransom_demand = this.crypto_negotiated_ransom_demand.slice(0, 12);
        return this.crypto_negotiated_ransom_demand;

        case 'negotiatedRansomDemand' : 
        if (this.negotiated_ransom_demand.length > 12) 
        this.negotiated_ransom_demand = this.negotiated_ransom_demand.slice(0, 12);
        return this.negotiated_ransom_demand;

        case 'trasectionfee' : 
        if (this.transactionfee.length > 5) 
        this.transactionfee = this.transactionfee.slice(0, 5);
        return this.transactionfee;

        case 'walletid' : 
        if (this.walletid.length > 75) 
        this.walletid = this.walletid.slice(0, 75);
        this.walletid =  this.walletid.replace(/[^a-zA-Z0-9\s]/g, '');
        return this.walletid;

        case 'secondarywalletid' : 
        if (this.secondaryWalletid.length > 75) 
        this.secondaryWalletid = this.secondaryWalletid.slice(0, 75);
        this.secondaryWalletid =  this.secondaryWalletid.replace(/[^a-zA-Z0-9\s]/g, '');
        return this.secondaryWalletid;
      };
    },
    addSecondaryWallet() {
      this.isSecondaryWalletActivated = true;
    },
    removeSecondaryWallet() {
      this.isSecondaryWalletActivated = false;
      this.secondaryWalletProjects = null;
      this.secondaryWalletid = "";
      this.walletNote = "";
      this.wallet_id_2_screenshot_files = [];
    },
    onOriginalRansomDemandCurrentyUpdated(input) {
      input = this.original_ransom_demand;
      if (input.length > 0 && this.original_ransom_demand_currency == "") {
        this.original_ransom_demand_currency = "USD";
      } else if (input.length == 0) {
        this.original_ransom_demand_currency = "";
      }
      this.validateInput('originalRansomDemand');
    },
    onNegotiatedRansomDemandCurrentyUpdated(input) {
      input = this.negotiated_ransom_demand;
      if (input.length > 0 && this.negotiated_ransom_demand_currency == "") {
        this.negotiated_ransom_demand_currency = "USD";
      } else if (input.length == 0) {
        this.negotiated_ransom_demand_currency = "";
      }
      this.validateInput('negotiatedRansomDemand');
    },
    checkFilesTypes(files) {
      let i = 0;
      for (i = 0; i < files.length; i++) {
        let fileContentType = files[i].type;
        let fileExtension = files[i].name.split(".").pop().toUpperCase();
        let allowdedExtensions = this.supportedFileTypesForWalletRequest();
        if (
          allowdedExtensions.indexOf(fileExtension) >= 0 ||
          fileContentType.startsWith("image/")
        ) {
        } else {
          return false;
        }
      }
      return true;
    },
    onPolChoiceChanged() {
      if (this.has_proof_of_life_completed === "false") {
        this.pol_files = [];
      }
    },
    getLabel(project) {
      return project.title;
    },
    combineAllFilesWithExceptCurrentObject(currentProperty) {
      let globalAllFiles = [];
      // get all file object using reflection

      let arrAllFilesProperty = Object.keys(this).filter((x) => {
        if (x.indexOf("files") >= 0) return x;
      });

      // remove current name object

      let arrAllFileObjectNamesWithoutCurrent = arrAllFilesProperty.filter(
        (x) => {
          if (currentProperty != x) return x;
        }
      );

      // combine all files object without current

      arrAllFileObjectNamesWithoutCurrent.forEach((fileProperty) => {
        let data = Reflect.get(this, fileProperty);
        globalAllFiles = globalAllFiles.concat(data);
      });

      let isDataAvailableInGlobalAllFiles =
        globalAllFiles.filter((e) => {
          if (
            Reflect.get(this, currentProperty).filter((i) => {
              if (i.name == e.name) return e;
            }).length > 0
          )
            return e;
        }).length > 0;
      return false == isDataAvailableInGlobalAllFiles;
    },
    createWalletRequest(e) {
      this.$v.$touch();
      setTimeout(() => {
        if (this.$v.$invalid) {
          this.scrollToLatestError();
        } else {
          e.target.disabled = true;
          this.$bvModal
            .msgBoxConfirm(
              "Please confirm that you want to create Wallet Request",
              {
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                cancelVariant: "danger",
                okTitle: "Yes",
                cancelTitle: "No",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              }
            )
            .then((value) => {
              if (value) {
                this.requestData = new FormData();
                this.requestData.append(
                  "ProjectDetails.Name",
                  this.selectedProject.title
                );
                this.requestData.append(
                  "ProjectDetails.ProjectId",
                  this.selectedProject.id
                );

                this.requestData.append("CryptoType", this.cryptotype);
                this.requestData.append("Variant", this.variant_name.join(","));
                this.requestData.append("Carrier", this.carrier_name);
                this.requestData.append(
                  "ThreatActorEmailAddress",
                  this.threat_actor_email_address
                );
                this.requestData.append("TorChatLink", this.tor_chat_link);
                this.requestData.append(
                  "ClientDomainName",
                  this.client_domain_name
                );
                this.requestData.append(
                  "RansomPaymentReason",
                  this.ransom_payment_reason
                );
                this.wallet_screenshot_files.forEach((w, index) => {
                  this.requestData.append(`WalletImages`, w);
                });
                this.wallet_id_2_screenshot_files.forEach((w, index) => {
                  this.requestData.append(`SecondaryWalletIdImages`, w);
                });
                this.requestData.append("WalletId", this.walletid);
                this.requestData.append(
                  "SecondaryWalletId",
                  this.secondaryWalletid
                );
                this.requestData.append(
                  "WalletNote",
                  this.walletNote
                );

                // this.requestData.append(
                //   "PaymentRequestedDate",
                //   this.paymentrequesteddate
                //  );

                this.requestData.append(
                  "CryptoOriginalRansomDemand",
                  this.crypto_original_ransom_demand
                );
                this.requestData.append(
                  "CryptoNegotiatedRansomDemand",
                  this.crypto_negotiated_ransom_demand
                );
                this.requestData.append(
                  "OriginalRansomDemand.Value",
                  this.original_ransom_demand
                );
                this.requestData.append(
                  "OriginalRansomDemand.Currency",
                  this.original_ransom_demand_currency
                );
                this.requestData.append(
                  "NegotiatedRansomDemand.Value",
                  this.negotiated_ransom_demand
                );
                this.requestData.append(
                  "NegotiatedRansomDemand.Currency",
                  this.negotiated_ransom_demand_currency
                );
                this.initial_ransom_payment_files.forEach((f, index) => {
                  this.requestData.append(`InitialRansomPaymentFiles`, f);
                });
                this.copy_of_ransome_note_files.forEach((f, index) => {
                  this.requestData.append(`CopyOfRansomeNoteFiles`, f);
                });
                this.complete_chat_history_files.forEach((f, index) => {
                  this.requestData.append(`CompleteChatHistoryFiles`, f);
                });
                this.final_ransom_payment_files.forEach((f, index) => {
                  this.requestData.append(`FinalRansomPaymentFiles`, f);
                });

                this.requestData.append(
                  "POLDetails.IsCompleted",
                  this.has_proof_of_life_completed === "true"
                );
                this.requestData.append(
                  "POLDetails.ConfirmationCommunication",
                  this.confirmation_communication
                );
                this.pol_files.forEach((f, index) => {
                  this.requestData.append(`POLDetails.Screenshots`, f);
                });

                this.requestData.append(
                  "ClientPhysicalAddress",
                  this.client_physical_address
                );
                this.carrier_emails.forEach((c, i) => {
                  this.requestData.append(
                    `CarrierDetails[${i}].Email`,
                    c.email
                  );
                  this.requestData.append(
                    `CarrierDetails[${i}].FullName`,
                    c.full_name
                  );
                });

                this.handleCustomFieldUpdate(
                  this.carrier_emails[0].email,
                  594255
                );
                this.handleCustomFieldUpdate(
                  this.carrier_emails[0].full_name,
                  582065
                );

                this.arete_emails.forEach((c, i) => {
                  this.requestData.append(
                    `AreteUserDetails[${i}].Email`,
                    c.email.mail
                  );
                  this.requestData.append(
                    `AreteUserDetails[${i}].FullName`,
                    c.email.displayName
                  );
                });

                this.client_emails.forEach((c, i) => {
                  this.requestData.append(`ClientDetails[${i}].Email`, c.email);
                  this.requestData.append(
                    `ClientDetails[${i}].IsPrimary`,
                    c.is_primary
                  );
                  this.requestData.append(
                    `ClientDetails[${i}].FullName`,
                    c.full_name
                  );
                });

                if (this.client_emails[0]) {
                  this.handleCustomFieldUpdate(
                    this.client_emails[0].email,
                    747235
                  );
                  this.handleCustomFieldUpdate(
                    this.client_emails[0].full_name,
                    747225
                  );
                }

                if (this.client_emails[1]) {
                  this.handleCustomFieldUpdate(
                    this.client_emails[1].email,
                    747255
                  );
                  this.handleCustomFieldUpdate(
                    this.client_emails[1].full_name,
                    747245
                  );
                }

                if (this.client_emails[2]) {
                  this.handleCustomFieldUpdate(
                    this.client_emails[2].email,
                    747275
                  );
                  this.handleCustomFieldUpdate(
                    this.client_emails[2].full_name,
                    747265
                  );
                }

                if (this.client_emails[3]) {
                  this.handleCustomFieldUpdate(
                    this.client_emails[3].email,
                    747295
                  );
                  this.handleCustomFieldUpdate(
                    this.client_emails[3].full_name,
                    747285
                  );
                }

                this.counsel_emails.forEach((c, i) => {
                  this.requestData.append(
                    `CounselDetails[${i}].Email`,
                    c.email
                  );
                  this.requestData.append(
                    `CounselDetails[${i}].FullName`,
                    c.full_name
                  );
                  this.requestData.append(
                    `CounselDetails[${i}].IsPartner`,
                    c.is_partner
                  );
                  this.requestData.append(
                    `CounselDetails[${i}].IsAssociate`,
                    c.is_associate
                  );
                });

                const partner_counsel = this.counsel_emails.find(
                  (e) => e.is_partner
                );
                const associate_counsel = this.counsel_emails.find(
                  (e) => e.is_associate
                );

                if (partner_counsel) {
                  this.handleCustomFieldUpdate(partner_counsel.email, 681225);
                  this.handleCustomFieldUpdate(
                    partner_counsel.full_name,
                    747215
                  );
                }

                if (associate_counsel) {
                  this.handleCustomFieldUpdate(associate_counsel.email, 681235);
                  this.handleCustomFieldUpdate(
                    associate_counsel.full_name,
                    747205
                  );
                }

                /* this.requestData.append(
                    "NotesAboutThreatActor",
                  this.notes_about_threat_actor
                ); */

                this.requestData.append(
                  "HasWalletIdBeenUsedEarlier",
                  this.walletProjects !== null && this.walletProjects.length > 0
                );
                this.requestData.append(
                  "HasSecondaryWalletIdBeenUsedEarlier",
                  this.secondaryWalletProjects !== null &&
                    this.secondaryWalletProjects.length > 0
                );
                this.updated_custom_fields.forEach((f, i) => {
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].WorkspaceCustomFieldId`,
                    f.id
                  );
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].CustomFieldId`,
                    f.custom_field_id
                  );
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].WorkspaceId`,
                    f.subject_id
                  );
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].Value`,
                    f.display_value
                  );
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].Name`,
                    f.custom_field_name
                  );
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].Type`,
                    f.type
                  );
                });

                this.requestData.append(
                  "RansomDemandedIn",
                  this.ransomdemandedin
                );
                this.requestData.append(
                  "RansomPaymentMode",
                  this.ransompaymentmode
                );
                this.requestData.append("TransactionFee", this.transactionfee);

                this.communication_details.forEach((c, i) => {
                  this.requestData.append(
                    `CommunicationDetails[${i}].Type`,
                    c.type
                  );
                  this.requestData.append(
                    `CommunicationDetails[${i}].Value`,
                    c.value
                  );
                });

                this.groups.forEach((g, i) => {
                  this.requestData.append(`BreachCoaches[${i}].Id`, g.id);
                  this.requestData.append(`BreachCoaches[${i}].Name`, g.name);
                });

                /* this.requestData.append(
                   "CurrentOfferFromArete.Value",
                  this.current_offer_from_arete
                );
                this.requestData.append(
                  "CurrentOfferFromArete.Currency",
                  this.current_offer_from_arete_currency
                );
                this.requestData.append(
                  "CurrentOfferFromTA.Value",
                  this.current_offer_from_ta
                );
                this.requestData.append(
                  "CurrentOfferFromTA.Currency",
                  this.current_offer_from_ta_currency
                ); */

                this.requestData.append(
                  "NegotiationStartDateAndTime",
                  this.negotiationstartdatetime
                );
                this.requestData.append(
                  "NegotiationEndDateAndTime",
                  this.negotiationenddatetime
                );

                this.threat_intel_files.forEach((f) => {
                  this.requestData.append(`ThreatIntelDocuments`, f);
                });

                EventBus.$emit("toast", {
                  title: "",
                  message: "Creating Wallet Request",
                  variant: "success",
                });
                var el$ = document.getElementById("createwalletrequest");
                el$.innerHTML = "Creating...";
                el$.style.animation = "fadinganimation 1s infinite";
                var that = this;
                walletService
                  .createWalletRequest(this.requestData)
                  .then((response) => {
                    el$.innerHTML = "Create";
                    el$.style.animation = "";
                    that.$store.commit("addWalletRequest", response.data.data);
                    EventBus.$emit("toast", {
                      title: "",
                      message: "Successfully created Wallet Request",
                      variant: "success",
                    });
                    that.$router.push({ name: "dashboard-view" });
                  })
                  .catch((err) => {
                    if (err.response && err.response.status == 409) {
                      EventBus.$emit("toast", {
                        title: "Error",
                        message: err.response.data.error.message,
                        variant: "danger",
                      });
                    } else if (err.toString() == "Error: Network Error") {
                      EventBus.$emit("toast", {
                        title: "Error",
                        message:
                          "File Upload was not successful as size > 30MB. Try sending it offline.",
                        variant: "danger",
                      });
                    }
                    e.target.disabled = false;
                    el$.innerHTML = "Create";
                    el$.style.animation = "";
                  });
              } else {
                e.target.disabled = false;
              }
            });
        }
      }, 50);
    },
    fetchProjects: _.debounce(function (name) {
      if (name) {
        this.isLoading = true;
        projectService
          .getProjects(name)
          .then((response) => {
            this.isLoading = false;
            this.projects = response.data.data;
          })
          .catch((err) => console.log(err));
      }
    }, 500),
    checkWalletId() {
      if (this.walletid) {
        var el$ = document.getElementById("btncheckwallet");
        el$.innerHTML = "Checking...";
        el$.style.animation = "fadinganimation 1s infinite";
        walletService
          .CheckWalletId(this.walletid)
          .then((response) => {
            el$.innerHTML = "Check";
            el$.style.animation = "";
            this.walletProjects = response.data.data;
          })
          .catch((err) => {});
      } else {
      }
    },
    checkSecondaryWalletId() {
      if (this.secondaryWalletid) {
        var el$ = document.getElementById("btnchecksecondarywallet");
        el$.innerHTML = "Checking...";
        el$.style.animation = "fadinganimation 1s infinite";
        walletService
          .CheckWalletId(this.secondaryWalletid)
          .then((response) => {
            el$.innerHTML = "Check";
            el$.style.animation = "";
            this.secondaryWalletProjects = response.data.data;
          })
          .catch((err) => {});
      } else {
      }
    },

    handleVariants(value) {
      if (
        this.variants.filter(
          (v) => v.toLowerCase().indexOf(value.toLowerCase()) !== -1
        ).length === 0
      ) {
        this.variants.shift();
        this.variants.unshift(value);
      }
    },
    oncloseVariant(){
      this.$refs.multiSelect.filterValue = "";
    },
    addNewPathNode(list, type) {
      switch (type) {
        case "client":
          list.push({ email: "", is_primary: false, full_name: "" });
          break;
        case "counsel":
          list.push({
            email: "",
            full_name: "",
            is_partner: false,
            is_associate: false,
          });
          break;
        case "carrier":
        case "areteuser":
          list.push({ email: "", full_name: "" });
          break;
        case "wallet_id":
          list.push({ value: "" });
          break;
        case "communication_detail":
          list.push({ type: "", value: "" });
        default:
          break;
      }
    },
    removePathNode(list, index) {
      list.splice(index, 1);
    },
    checkEmail(email, model, index) {
      this.$v[model].$touch();
    },

    checkIfWalletRequestIsAlreadyInitiated(projectId) {
      walletService
        .checkIfWalletRequestIsAlreadyInitiated(projectId)
        .then()
        .catch((err) => {
          if (err.response.status == 409) {
            EventBus.$emit("toast", {
              title: "Error",
              message: err.response.data.error.message,
              variant: "danger",
            });
          } else {
            (err) => console.log(err);
          }
        });
    },
    getProjectDetails(selectedOption, id) {
      this.removeProjectDetails();
      EventBus.$emit("toast", {
        title: "",
        message: "Fetching Project Details from Mavenlink",
        variant: "success",
      });
      let loading_element = document.getElementById("loadingcontainer");
      let main_container = document.getElementById("crequestcontainer");
      loading_element.classList.remove("d-none");
      main_container.classList.add("blurfilter");
      const projectId = selectedOption.id;
      projectService
        .getProjectDetails(projectId, false)
        .then((response) => {
          this.checkIfWalletRequestIsAlreadyInitiated(projectId);
          this.project_custom_fields = response.data.data.custom_fields;
          this.client_domain_name = this.getCustomFieldValueById(650735);
          this.groups = response.data.data.groups;
          this.carrier_name = this.getCustomFieldValueById(598475);
          const variant = this.getCustomFieldValueById(571045);
          if (response.data.data.projectManagerEmail) {
            this.arete_emails = [];
            this.arete_emails.push({
              email: { mail: response.data.data.projectManagerEmail },
            });
            this.arete_emails.push({
              email: "",
            });
          }
          if (variant) {
            this.variant_name = variant.split(",").map((v) => v.trim());
          }
          this.ransom_payment_reason = this.getCustomFieldValueById(650875);
          //this.cryptotype = this.getCustomFieldValueById(682855);
          // defaut crypto type is BTC
          this.cryptotype = "BTC";
          this.crypto_original_ransom_demand =
            this.getCustomFieldValueById(566695);
          this.crypto_negotiated_ransom_demand =
            this.getCustomFieldValueById(566675);
          this.original_ransom_demand = this.getCustomFieldValueById(
            689325
          ).replace(/[^0-9.]+/g, "");
          this.negotiated_ransom_demand = this.getCustomFieldValueById(
            572015
          ).replace(/[^0-9.]+/g, "");
          const walletid = this.getCustomFieldValueById(572035);
          if (walletid) {
            this.walletid = walletid;
            this.checkWalletId();
          }
          this.client_physical_address = this.formClientPhysicalAddress();
          this.carrier_emails[0].email = this.getCustomFieldValueById(594255);
          this.carrier_emails[0].full_name =
            this.getCustomFieldValueById(582065);

          const client_full_name_1 = this.getCustomFieldValueById(747225);
          const client_email_1 = this.getCustomFieldValueById(747235);
          const client_full_name_2 = this.getCustomFieldValueById(747245);
          const client_email_2 = this.getCustomFieldValueById(747255);
          const client_full_name_3 = this.getCustomFieldValueById(747265);
          const client_email_3 = this.getCustomFieldValueById(747275);
          const client_full_name_4 = this.getCustomFieldValueById(747285);
          const client_email_4 = this.getCustomFieldValueById(747295);

          this.client_emails = [];
          if (client_full_name_1 || client_email_1) {
            this.client_emails.push({
              email: client_email_1,
              full_name: client_full_name_1,
              is_primary: false,
            });
          }
          if (client_full_name_2 || client_email_2) {
            this.client_emails.push({
              email: client_email_2,
              full_name: client_full_name_2,
              is_primary: false,
            });
          }
          if (client_full_name_3 || client_email_3) {
            this.client_emails.push({
              email: client_email_3,
              full_name: client_full_name_3,
              is_primary: false,
            });
          }
          if (client_full_name_4 || client_email_4) {
            this.client_emails.push({
              email: client_email_4,
              full_name: client_full_name_4,
              is_primary: false,
            });
          }

          if (!this.client_emails.length) {
            this.client_emails.push({
              email: "",
              full_name: "",
              is_primary: false,
            });
          }
          const partner_email = this.getCustomFieldValueById(681225);
          const partner_full_name = this.getCustomFieldValueById(747215);
          const associate_email = this.getCustomFieldValueById(681235);
          const associate_full_name = this.getCustomFieldValueById(747205);

          if (partner_email || partner_full_name) {
            this.counsel_emails[0].email = partner_email;
            this.counsel_emails[0].full_name = partner_full_name;
            this.counsel_emails[0].is_partner = true;
            this.counsel_emails[0].is_associate = false;
          }

          if (associate_email || associate_full_name) {
            this.counsel_emails[1].email = associate_email;
            this.counsel_emails[1].full_name = associate_full_name;
            this.counsel_emails[1].is_partner = false;
            this.counsel_emails[1].is_associate = true;
          }
        })
        .catch((err) => {
          loading_element.classList.add("d-none");
        })
        .finally(() => {
          main_container.classList.remove("blurfilter");
          loading_element.classList.add("d-none");
        });
    },
    removeProjectDetails(removedOption) {
      this.project_custom_fields = [];
      this.updated_custom_fields = [];
      this.carrier_name = "";
      this.variant_name = "";
      this.ransom_payment_reason = "";
      this.cryptotype = "";
      this.crypto_original_ransom_demand = "";
      this.crypto_negotiated_ransom_demand = "";
      this.original_ransom_demand = "";
      this.negotiated_ransom_demand = "";
      this.walletid = "";
      this.secondaryWalletid = "";
      this.client_physical_address = "";
      (this.carrier_emails = [
        {
          email: "",
          full_name: "",
        },
      ]),
        (this.arete_emails = [
          {
            email: "",
          },
        ]),
        (this.client_emails = [
          {
            email: "",
            is_primary: false,
            full_name: "",
          },
        ]),
        (this.counsel_emails = [
          {
            email: "",
            full_name: "",
            is_partner: false,
            is_associate: false,
          },
          {
            email: "",
            full_name: "",
            is_partner: false,
            is_associate: false,
          },
        ]);
    },
    getCustomFieldValue(custom_field) {
      const cField = this.project_custom_fields.find(
        (c) => c.custom_field_name.trim() === custom_field
      );
      if (cField) {
        return cField.display_value;
      }
      return "";
    },
    getCustomFieldValueById(id) {
      const cField = this.project_custom_fields.find(
        (c) => c.custom_field_id === id
      );
      if (cField) {
        return cField.display_value;
      }
      return "";
    },
    formClientPhysicalAddress() {
      const address = this.getCustomFieldValueById(602135);
      const city = this.getCustomFieldValueById(602145);
      const state = this.getCustomFieldValueById(602155);
      const country = this.getCustomFieldValueById(602165);
      const postal_code = this.getCustomFieldValueById(747185);
      let address_str = [address, city, state, country, postal_code];
      return address_str.filter((a) => a !== "").join(",");
    },
    handleCustomFieldUpdate(value, field_id) {
      const index = this.updated_custom_fields.findIndex(
        (c) => c.custom_field_id === field_id
      );
      if (index !== -1) {
        this.updated_custom_fields.splice(index, 1);
      }
      let cur_value = this.getCustomFieldValueById(field_id);
      if (field_id === 689325 || field_id === 572015) {
        cur_value = cur_value.replace(/[^0-9.]+/g, "");
      }
      if (value !== cur_value) {
        let field = this.project_custom_fields.find(
          (c) => c.custom_field_id === field_id
        );
        let cField = { ...field };
        if (Array.isArray(value)) {
          cField.display_value = value.join(",");
        } else {
          cField.display_value = value;
        }
        this.updated_custom_fields.push(cField);
      }
    },
    makeCounselAsPartner(index) {
      this.counsel_emails.forEach((e) => {
        e.is_partner = false;
      });
      this.counsel_emails[index].is_partner =
        !this.counsel_emails[index].is_partner;
    },
    makeCounselAsAssociate(index) {
      this.counsel_emails.forEach((e) => {
        e.is_associate = false;
      });
      this.counsel_emails[index].is_associate =
        !this.counsel_emails[index].is_associate;
    },
  },
  watch: {
    isSecondaryWalletActivated: function () {
      this.isCreateWalletVisible;
    },
    walletProjects: function () {
      this.isCreateWalletVisible;
    },
    secondaryWalletProjects: function () {
      this.isCreateWalletVisible;
    },
    secondaryWalletid: function () {
      this.secondaryWalletProjects = null;
    },
    walletid(w) {
      this.walletProjects = null;
      this.handleCustomFieldUpdate(w, 572035);
    },
    carrier_name(c) {
      this.handleCustomFieldUpdate(c, 598475);
    },
    variant_name(v) {
      this.handleCustomFieldUpdate(v, 571045);
    },
    ransom_payment_reason(r) {
      this.handleCustomFieldUpdate(r, 650875);
    },
    cryptotype(c) {
      this.handleCustomFieldUpdate(c, 682855);
    },
    crypto_original_ransom_demand(c) {
      this.handleCustomFieldUpdate(c, 566695);
    },
    crypto_negotiated_ransom_demand(c) {
      this.handleCustomFieldUpdate(c, 566675);
    },
    original_ransom_demand(o) {
      this.handleCustomFieldUpdate(o, 689325);
    },
    negotiated_ransom_demand(n) {
      this.handleCustomFieldUpdate(n, 572015);
    },
  },
  computed: {
    ...mapState({
      customFields: (state) => state.customFields,
      currencies: (state) => state.currencies,
      isCreateWalletVisible: function () {
        if (this.isSecondaryWalletActivated == false) {
          return this.walletProjects == null;
        } else {
          return (
            this.walletProjects == null || this.secondaryWalletProjects == null
          );
        }
      },
    }),
    currencyUnit() {
      return this.cryptotype == "" ? "" : this.cryptotype;
    },
    variants: {
      get() {
        let variants = this.$store.getters.customFieldChoicesById(571045);
        //variant is dropdown is multiselect, so it doesnt required blank entry in dropdown
        variants.shift();
        return variants;
      },
      set(value) {
        this.variants = value;
      },
    },
    carriers() {
      let carriers = this.$store.getters.customFieldChoicesById(598475);
      return carriers.filter(option => option !== "");
    },
    crypto_types() {
      let options = this.$store.getters.customFieldChoicesById(682855);
      return options.filter(option => option !== "");
    },
    ransom_payment_reasons() {
      let options = this.$store.getters.customFieldChoicesById(650875);
      return options.filter(option => option !== "");
    },
  },
  data() {
    return {
      isSecondaryWalletActivated: false,
      walletProjects: null,
      secondaryWalletProjects: null,
      projectname: "",
      errorMsgAlreadyUploadedFile:
        "File already uploaded. Please select a unique file while creating a wallet request",
      cryptotype: "BTC",
      walletid: "",
      secondaryWalletid: "",
      walletNote: "",
      paymentrequesteddate: "",
      crypto_original_ransom_demand: "",
      crypto_negotiated_ransom_demand: "",
      original_ransom_demand: "",
      negotiated_ransom_demand: "",
      projects: [],
      selectedProject: {},
      isLoading: false,
      wallet_screenshot_files: [],
      wallet_id_2_screenshot_files:[],
      requestData: "",
      variant_name: "",
      carrier_name: "",
      client_domain_name: "",
      carrier_emails: [
        {
          email: "",
          full_name: "",
        },
      ],
      arete_emails: [
        {
          email: "",
        },
      ],
      client_emails: [
        {
          email: "",
          is_primary: false,
          full_name: "",
        },
      ],
      counsel_emails: [
        {
          email: "",
          full_name: "",
          is_partner: false,
          is_associate: false,
        },
        {
          email: "",
          full_name: "",
          is_partner: false,
          is_associate: false,
        },
      ],
      has_proof_of_life_completed: "",
      confirmation_communication: "",
      pol_files: [],
      client_physical_address: "",
      // notes_about_threat_actor: "",
      fileTypeNotSupported:
        "File type not supported. Please upload Word, PDF, TXT or Image file.",
      initial_ransom_payment_files: [],
      copy_of_ransome_note_files: [],
      complete_chat_history_files: [],
      final_ransom_payment_files: [],
      arete_master_emails: [],
      ransom_payment_reason: "",
      project_custom_fields: [],
      updated_custom_fields: [],
      ransomdemandedin: "",
      ransompaymentmode: "",
      transactionfee: "",
      communication_details: [
        {
          type: "",
          value: "",
        },
      ],
      negotiationstartdatetime: "",
      negotiationenddatetime: "",
      original_ransom_demand_currency: "",
      negotiated_ransom_demand_currency: "",
      // current_offer_from_arete: "",
      // current_offer_from_arete_currency: "",
      // current_offer_from_ta: "",
      // current_offer_from_ta_currency: "",
      groups: [],
      breadcrumb_items: [
        {
          text: "Dashboard",
          to: { name: "dashboard-view" },
        },
        {
          text: "Create Request",
          active: true,
        },
      ],
      threat_intel_files: [],
      variantLimit: 3
    };
  },
  validations: {
    selectedProject: { required },
    cryptotype: { required },
    walletid: {
      required,
      unique(walletid) {
          return walletid != this.secondaryWalletid;
      },
    },
    secondaryWalletid: {
      required: requiredIf(function () {
        return this.isSecondaryWalletActivated;
      }),
      unique(secondaryWalletid) {
        if (this.walletid) {
          return secondaryWalletid != this.walletid;
        }
        return true;
      },
    },
    walletNote: {
      required: requiredIf(function () {
        return this.isSecondaryWalletActivated;
      }),
    },
    wallet_screenshot_files: {
      required,
      allowdedFileTypes: function (files) {
        return this.checkFilesTypes(files);
      },
      unique() {
        let names = this.wallet_screenshot_files.map((s) => s.name);
        return new Set(names).size === names.length;
      },
      uniqueGlobal(files) {
        return this.combineAllFilesWithExceptCurrentObject(
          "wallet_screenshot_files"
        );
      },
    },
    wallet_id_2_screenshot_files: {
      required: requiredIf(function () {
        return this.isSecondaryWalletActivated;
      }),
      allowdedFileTypes: function (files) {
        return this.checkFilesTypes(files);
      },
      unique() {
        let names = this.wallet_id_2_screenshot_files.map((s) => s.name);
        return new Set(names).size === names.length;
      },
      uniqueGlobal(files) {
        return this.combineAllFilesWithExceptCurrentObject(
          "wallet_id_2_screenshot_files"
        );
      },
    },
    variant_name: { required },
    has_proof_of_life_completed: { required },

    threat_actor_email_address: {
      required: requiredIf(function () {
        return this.tor_chat_link === "";
      }),
      email,
    },

    tor_chat_link: {
      required: requiredIf(function () {
        return this.threat_actor_email_address === "";
      }),
    },
    carrier_name: { required },
    client_domain_name: { required },
    // carrier_emails: {
    //   required,
    //   $each: { email: { required, email }, full_name: { required } },
    // },
    threat_intel_files: {
      allowdedFileTypes: function (files) {
        return this.checkFilesTypes(files);
      },
      unique(files) {
        let names = this.threat_intel_files.map((s) => s.name);
        return new Set(names).size === names.length;
      },
      uniqueGlobal(files) {
        return this.combineAllFilesWithExceptCurrentObject(
          "threat_intel_files"
        );
      },
    },
    pol_files: {
      required: requiredIf(function () {
        return this.has_proof_of_life_completed === "true";
      }),
      allowdedFileTypes: function (files) {
        return (
          this.has_proof_of_life_completed === "false" ||
          this.checkFilesTypes(files)
        );
      },
      unique(files) {
        let names = this.pol_files.map((s) => s.name);
        return (
          this.has_proof_of_life_completed === "false" ||
          new Set(names).size === names.length
        );
      },
      uniqueGlobal(files) {
        return (
          this.has_proof_of_life_completed === "false" ||
          this.combineAllFilesWithExceptCurrentObject("pol_files")
        );
      },
    },
    confirmation_communication: {
      required: requiredIf(function () {
        return this.has_proof_of_life_completed === "false";
      }),
    },
    client_physical_address: { required },
    communication_details: {
      required,
      $each: { type: { required }, value: { required } },
    },
    arete_emails: {
      required,
      $each: { email: { mail: { required, email } } },
    },
    client_emails: {
      required,
      $each: { email: { required, email }, full_name: { required } },
    },
    counsel_emails: {
      required,
      $each: { email: { email } },
    },
    initial_ransom_payment_files: {
      required,
      allowdedFileTypes: function (files) {
        return this.checkFilesTypes(files);
      },
      unique(files) {
        let names = this.initial_ransom_payment_files.map((s) => s.name);
        return new Set(names).size === names.length;
      },
      uniqueGlobal(files) {
        return this.combineAllFilesWithExceptCurrentObject(
          "initial_ransom_payment_files"
        );
      },
    },
    copy_of_ransome_note_files: {
      required,
      allowdedFileTypes: function (files) {
        return this.checkFilesTypes(files);
      },
      unique(files) {
        let names = this.copy_of_ransome_note_files.map((s) => s.name);
        return new Set(names).size === names.length;
      },
      uniqueGlobal(files) {
        return this.combineAllFilesWithExceptCurrentObject(
          "copy_of_ransome_note_files"
        );
      },
    },
    complete_chat_history_files: {
      required,
      allowdedFileTypes: function (files) {
        return this.checkFilesTypes(files);
      },
      unique(files) {
        let names = this.complete_chat_history_files.map((s) => s.name);
        return new Set(names).size === names.length;
      },
      uniqueGlobal(files) {
        return this.combineAllFilesWithExceptCurrentObject(
          "complete_chat_history_files"
        );
      },
    },
    final_ransom_payment_files: {
      required,
      allowdedFileTypes: function (files) {
        return this.checkFilesTypes(files);
      },
      unique(files) {
        let names = this.final_ransom_payment_files.map((s) => s.name);
        return new Set(names).size === names.length;
      },
      uniqueGlobal(files) {
        return this.combineAllFilesWithExceptCurrentObject(
          "final_ransom_payment_files"
        );
      },
    },
    original_ransom_demand: {
      required: requiredIf(function () {
        return this.original_ransom_demand === "";
      }),
    },
    negotiated_ransom_demand: {
      required: requiredIf(function () {
        return this.crypto_negotiated_ransom_demand === "";
      }),
    },
    original_ransom_demand: {
      required: requiredIf(function () {
        return this.crypto_original_ransom_demand === "";
      }),
    },

    ransom_payment_reason: { required },
    ransomdemandedin: { required },
    ransompaymentmode: { required },
    transactionfee: { required, between: between(0, 100) },
    negotiationstartdatetime: { required },
    negotiationenddatetime: { required },
    negotiated_ransom_demand_currency: {
      required: requiredIf(function () {
        return this.negotiated_ransom_demand !== "";
      }),
    },
    original_ransom_demand_currency: {
      required: requiredIf(function () {
        return this.original_ransom_demand !== "";
      }),
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
#crequestcontainer {
  width: 85%;
  margin: auto;
  margin-top: 40px;
  transition: 0.5s;
}

.blurfilter {
  filter: blur(10px);
}

#amountcontainer {
  justify-content: space-between;
}

.mx-datepicker {
  width: 100% !important;
}

.form-group--error {
  scroll-margin-top: 70px;
}

.error {
  animation-name: shakeError;
  animation-fill-mode: forwards;
  animation-duration: 0.6s;
  animation-timing-function: ease-in-out;
  display: block;
  color: #f57f6c;
}

@keyframes shakeError {
  0% {
    transform: translateX(0);
  }
  15% {
    transform: translateX(0.375rem);
  }
  30% {
    transform: translateX(-0.375rem);
  }
  45% {
    transform: translateX(0.375rem);
  }
  60% {
    transform: translateX(-0.375rem);
  }
  75% {
    transform: translateX(0.375rem);
  }
  90% {
    transform: translateX(-0.375rem);
  }
  100% {
    transform: translateX(0);
  }
}

.multiselect {
  min-height: 30px !important;
  border: 1px solid #ced4da;
    border-radius: 0.25rem;
}

.multiselect__single,
.multiselect__input,
.multiselect__element {
  line-height: 11px !important;
  font-size: 13.333px !important;
}

.multiselect__tags {
  min-height: 30px !important;
  height: 30px !important;
}
.custom-multiselect {
  width: 100%; /* Set the desired width */
  border: 1px solid #ced4da !important;
}
.p-multiselect-panel .p-checkbox {
  display: none;
}
// .p-multiselect.p-multiselect-chip .p-multiselect-token .p-multiselect-token-icon{
//   margin-top: 3px;
// }
.p-multiselect:not(.p-disabled):hover{
  border-color: #ced4da !important;
}
.multiselect__tag {
  margin-top: -4px;
  font-size: 12px;
}

.multiselect__select {
  height: 30px !important;
}

.multiselect__placeholder {
  position: absolute;
  top: 5px;
}

.multiselect__content-wrapper {
  overflow: auto !important;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.loading {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  color: $primary-color;
}

.w-50 {
  width: 50% !important;
}
.position-inline-block {
  display: inline-block;
}
.display-flex {
  display: flex;
}
.p-multiselect {
    min-width: 15rem;
}
.p-multiselect-trigger-icon {
  margin-top: 57% !important;
}
.pi-chevron-down:before{
  position: relative;
    right: 0;
    top: 65%;
    color: #999;
    margin-top: 4px;
  border-color: #999 transparent transparent;
    border-style: solid;
    border-width: 5px 5px 0;
    content: "" !important; 
}
:deep(.custom-multiselect) {
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: .25rem;
        padding-bottom: .25rem;
    }
}
</style>